import PropTypes from 'prop-types'
import { StatusFilter } from './components'

const ComplaintFilter = (props) => {
  const { filterStatus, onFilterStatusChange } = props

  return (
    <StatusFilter
      filterParams={filterStatus}
      setFilterParams={onFilterStatusChange}
    />
  )
}

ComplaintFilter.propTypes = {
  filterStatus: PropTypes.object,
  onFilterStatusChange: PropTypes.func
}

export default ComplaintFilter
